// extracted by mini-css-extract-plugin
module.exports = {"header":"ChooseProperty_style_header__2nu8I","list":"ChooseProperty_style_list__7CSop","item":"ChooseProperty_style_item__3Npzr"};